import {
  switchOptions,
  selectOptionclassification,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { ActionTypes } from './types';
import { getDoorType, removeHiddenComponents } from './Selectors';

interface CustomData {
  [name: string]: string | number | object;
}

const createSelectNoDoorOptionIfAllRemoved = () => (dispatch, getState) => {
  const configuration = getState().configurator.configuration;
  const currentDoorType = getDoorType(configuration)?.identifier;
  if (!configuration.customdata?.doors?.length && currentDoorType && currentDoorType !== 'no_door') {
    const switchOptionData = {
      door_types: {
        identifier: 'no_door',
        amount: 1,
      },
    };
    return dispatch(switchOptions(configuration, switchOptionData, false, false, true));
  }
};

export const setCustomData = (data: CustomData) => (dispatch) => {
  dispatch({
    type: ActionTypes.SET_CUSTOM_DATA,
    data,
  });
  dispatch(createSelectNoDoorOptionIfAllRemoved());
};

export const setDoor = (wall: string, position: number) => (dispatch, getState) => {
  const doors = getState().configurator.configuration.customdata?.doors || [];
  dispatch(setCustomData({ doors: [...doors, { wall, position }].sort((a, b) => a.position - b.position) }));
};

export const removeDoor = (wall: string, position: number) => (dispatch, getState) => {
  const doors = (getState().configurator.configuration.customdata?.doors || []).filter(
    (door) => !(door.wall === wall && door.position === position)
  );
  dispatch(setCustomData({ doors }));
};

export const removeAllDoors = () => (dispatch) => {
  dispatch(setCustomData({ doors: [] }));
};

export const selectFirstComponent = () => (dispatch, getState) => {
  const { configurator } = getState();
  const { filteredOptionclassifications } = configurator;
  const firstComponent = removeHiddenComponents(filteredOptionclassifications)[0];
  dispatch(selectOptionclassification(firstComponent, true, true));
};
